export default __webpack_public_path__ + "static/SR France - Dérivés Microbiens - Note d'information-6ef6fca6dd7585df2154102c236417f2.pdf";